module.exports = __webpack_public_path__ + "static/media/DSC_0280.d64476a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0280.jpg
// module id = 659
// module chunks = 0